import { render, staticRenderFns } from "./ListImageArticle.vue?vue&type=template&id=ca0e501c"
import script from "./ListImageArticle.ts?vue&type=script&lang=ts&external"
export * from "./ListImageArticle.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports